module.exports = function () {
	$(".C2-search-results__sample").on("click", ".C2-search-results__add", function (e) {
		e.preventDefault();
		var cartButton = $(this);
		$.ajax({
			url: "/customercenter-api/addproductsampletocart?Id=" + cartButton.data("id"),
			success: function (data) {
				console.log(data);
				var dataItem = JSON.parse(data);
				console.log(dataItem);
				cartButton.removeClass();
				cartButton.addClass("C2-search-results__remove");
				cartButton.text("Remove from Cart");
				var resultsString = $('.C5-2-fixed-bottom-bar__next').text().replace(/\d+/g, dataItem.totalProductCount);
				$('.C5-2-fixed-bottom-bar__next').text(resultsString);
				$('.header-login-control .login-modal-cart-item-count').text('(' + dataItem.totalProductCount + ')');
			}
		});
	});

	$(".C2-search-results__sample").on("click", ".C2-search-results__remove", function (e) {
		e.preventDefault();
		var cartButton = $(this);
		$.ajax({
			url: "/customercenter-api/removeproductsamplefromcart?Id=" + cartButton.data("id"),
			success: function (data) {
				var dataItem = JSON.parse(data);
				cartButton.removeClass();
				cartButton.addClass("C2-search-results__add");
				cartButton.text("Add to Cart");
				var resultsString = $('.C5-2-fixed-bottom-bar__next').text().replace(/\d+/g, dataItem.totalProductCount);
				$('.C5-2-fixed-bottom-bar__next').text(resultsString);
				$('.header-login-control .login-modal-cart-item-count').text('(' + dataItem.totalProductCount + ')');
			}
		});
	});

	$(".D3-sample-cart").on("click", ".D3-sample-cart__remove-button .D3-sample-cart__button", function (e) {
		var headerText = $('.header-login-control .login-modal-cart-item-count').text();
		var currentCount = parseInt(headerText.replace(/\D+/g, ''));
		$.ajax({
			url: "/api/search/ProductsWildcard/GetCartInfo",
			success: function (data) {
				if (data.Success) {
					var updatedValue;
					if (data.NumberOfItemsInCart == currentCount) {
						updatedValue = Math.max(currentCount - 1, 0);
					} else {
						updatedValue = data.NumberOfItemsInCart;
					}
					$('.header-login-control .login-modal-cart-item-count').text('(' + updatedValue + ')');
				}
			}
		});
	});
};
